import React from "react";
import Datatable from "../../../../partials/datatable/Datatable";
import AdminDropdown from "../../../../partials/content/CustomDropdowns/AdminDropdown";
import Moment from "moment";
import Loading from "../../../home/components/Loading";
import { ProposalIcon } from "../../../../components/IconsSVG";
import {
  StyledTableCell,
  StyledTableRow
} from "../../../../partials/datatable/styles";

const initialState = {
  proposalValues: [],
  reload: false,
  loading: false
};

export default class ProposalListing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...initialState
    };

    // this.handleConfirmChangeStatus = this.handleConfirmChangeStatus.bind(this);
    this.formatRow = this.formatRow.bind(this);
    this.setProposalValues = this.setProposalValues.bind(this);
  }

  setProposalValues = proposalValues => {
    this.setState({ proposalValues });
  };

  formatRow = r => {
    const valorFormatado = r.value ? `R$ ${r.value.toFixed(2)}` : "--";
    return (
      <StyledTableRow hover tabIndex={-1} key={r.idClient}>
        <StyledTableCell scope="row" align="left">
          {r.profileDescription && r.profileDescription}
        </StyledTableCell>
        <StyledTableCell scope="row" al ign="left">
          {r.supplier && r.supplier}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {r.name && r.name}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {!!r.validityStartDate &&
            Moment(r.validityStartDate).format("DD/MM/YYYY")}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {!!r.validityEndDate &&
            Moment(r.validityEndDate).format("DD/MM/YYYY")}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {r.model && r.model}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {r.profile && r.profile}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {r.level && r.level}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {r.tableLevel && r.tableLevel}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {r.range && r.range}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {valorFormatado}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {r.ipt && r.ipt}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {r.type && r.type}
        </StyledTableCell>
      </StyledTableRow>
    );
  };

  render() {
    window.setPageTitle("Listagem de Detalhe da Proposta - Admin");

    const headRows = [
      { column: "ProfileDescription", label: "Decrição do Perfil" },
      { column: "Supplier", label: "Fornecedor" },
      { column: "Name", label: "Nome da Proposta" },
      { column: "ValidityStartDate", label: "Início da Vigência" },
      { column: "ValidityEndDate", label: "Fim da Vigência" },
      { column: "Model", label: "Modelo" },
      { column: "Profile", label: "Perfil" },
      { column: "Level", label: "Nível Simplificado" },
      { column: "TableLevel", label: "Nível Tabela" },
      { column: "Range", label: "Faixa" },
      { column: "Value", label: "Valor" },
      { column: "IPT", label: "IPT" },
      { column: "Type", label: "Tipo" }
    ];

    return (
      <>
        <Loading isLoading={this.state.loading} />
        <Datatable
          title="Detalhe da Proposta"
          icon={ProposalIcon}
          endpoint={`/businessProposal/values/${this.props.match.params?.id}`}
          notPaginated={true}
          className="h-100"
          headRows={headRows}
          formatRow={this.formatRow}
          rows={this.state.proposalValues}
          setRows={this.setProposalValues}
          reload={this.state.reload}
          placeholderSearch="Busque por proposta ou descrição do perfil"
          mobile={AdminDropdown}
          width={this.props.width}
          hiddenReload
          hiddenFooterPagination
        />
      </>
    );
  }
}
